module.exports = __webpack_public_path__ + "static/media/luggers-moving-generic_2x.b3fb3eb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/luggers-moving-generic_2x.png
// module id = 1212
// module chunks = 27